<template>
<div class="chapter">
<div class="inner_page">
<h1 class="hide">Contents</h1>
<p class="x-2-chapter-title">Contents</p>
<p class="Basic-Paragraph para-style-override-6"></p>
<p class="contents-page para-style-override-12"><span></span></p>
<p class="contents-page"><a href="#/Text/Foreword">Foreword</a> </p>
<p class="contents-page"><a href="#/Text/Introduction">Introduction</a> </p>
<p class="contents-page"><a href="#/Text/CGHp01">The One-Armed Bandit</a> </p>
<p class="contents-page"><span href="#/Text/CGHp02" title="Link target outside of Sample">Five Little Ones</span> </p>
<p class="contents-page"><span href="#/Text/CGHp03" title="Link target outside of Sample">The Soup Bowl</span> </p>
<p class="contents-page"><span href="#/Text/CGHp04" title="Link target outside of Sample">Who Picked Alexandria?</span> </p>
<p class="contents-page"><span href="#/Text/CGHp05" title="Link target outside of Sample">Creativity, Inc.</span> </p>
<p class="contents-page"><span href="#/Text/CGHp06" title="Link target outside of Sample">I Hate It When the Pilot Says That</span> </p>
<p class="contents-page"><span href="#/Text/CGHp07" title="Link target outside of Sample">Everything Is Biblical Proportions!</span> </p>
<p class="contents-page"><span href="#/Text/CGHp08_a" title="Link target outside of Sample">Meanwhile, Back at the Ranch</span> </p>
<p class="contents-page"><span href="#/Text/CGHp09" title="Link target outside of Sample">You Didn’t Bring Enough for Everybody</span> </p>
<p class="contents-page"><span href="#/Text/CGHp10" title="Link target outside of Sample">On the River</span> </p>
<p class="contents-page"><span href="#/Text/CGHp11" title="Link target outside of Sample">On the Island, or Not</span> </p>
<p class="contents-page"><span href="#/Text/CGHp12" title="Link target outside of Sample">Rescue from Above</span> </p>
<p class="contents-page"><span href="#/Text/CGHp13" title="Link target outside of Sample">Whatever Needed to Be Done</span> </p>
<p class="contents-page"><span href="#/Text/CGHp14" title="Link target outside of Sample">I Need a Father Mulcahy! </span><br/></p>
<p class="contents-page"><span href="#/Text/CGHp15" title="Link target outside of Sample">The Rescues Continue</span> </p>
<p class="contents-page"><span href="#/Text/CGHp16" title="Link target outside of Sample">Relief and Recovery </span><br/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?1d53708b